// 3D Thumbnails
import Medira_tmb from'../Images/Art3D/MediraWolfdaughter_tmb.jpg';
import Guildhall_tmb from'../Images/Art3D/GuildHall_tmb.jpg';
import WizardTower_tmb from'../Images/Art3D/WizardTower_tmb.jpg';

// 2D Thumbnails
import Nocturne_tmb from'../Images/Art2D/Nocturne_tmb.jpg';
import Anjelica_tmb from'../Images/Art2D/Anjelica_tmb.jpg';
import Ann_tmb from'../Images/Art2D/Ann_tmb.jpg';
import ColdEyes_tmb from'../Images/Art2D/ColdEyes_tmb.jpg';
import GirlWithHat_tmb from'../Images/Art2D/GirlWithHat_tmb.jpg';
import OceanEyes_tmb from'../Images/Art2D/OceanEyes_tmb.jpg';
import Tanya_tmb from'../Images/Art2D/Tanya_tmb.jpg';

// 2D Images
import Nocturne_img from'../Images/Art2D/Nocturne_img.jpg';
import Anjelica_img from'../Images/Art2D/Anjelica_img.jpg';
import Ann_img from'../Images/Art2D/Ann_img.jpg';
import ColdEyes_img from'../Images/Art2D/ColdEyes_img.jpg';
import GirlWithHat_img from'../Images/Art2D/GirlWithHat_img.jpg';
import OceanEyes_img from'../Images/Art2D/OceanEyes_img.jpg';
import Tanya_img from'../Images/Art2D/Tanya_img.jpg';

// Assets 3D
import LPNEP_HBG from '../Images/Assets/LPNEP/HeaderBG.jpg'



//                                   ARTWORKS
// ______________________________________________________________________________

function getThumbnails3D(){
    return [
        ['medira', Medira_tmb],
        ['guildhall', Guildhall_tmb],
        ['wizardtower', WizardTower_tmb]
    ];
}

function getThumbnails2D(){
    return [
        ['nocturne', Nocturne_tmb],
        ['tanya', Tanya_tmb],
        ['oceaneyes', OceanEyes_tmb],
        ['anjelica', Anjelica_tmb],
        ['ann', Ann_tmb],
        ['girlwithhat', GirlWithHat_tmb],
        ['coldeyes', ColdEyes_tmb]
    ];
}

function getProjectData(id){
    switch(id){
        case 'nocturne':
            return {
                name: 'Child of Nocturne',
                thumbnail: Nocturne_tmb,
                image: Nocturne_img,
                artstation: 'https://www.artstation.com/artwork/q9WXWy'
            }
        case 'anjelica':
            return {
                name: 'Anjelica',
                thumbnail: Anjelica_tmb,
                image: Anjelica_img,
                artstation: 'https://www.artstation.com/artwork/xJzQ4O'
            }
        case 'ann':
            return {
                name: 'Ann',
                thumbnail: Ann_tmb,
                image: Ann_img,
                artstation: 'https://www.artstation.com/artwork/ba1lla'
            }
        case 'coldeyes':
            return {
                name: 'Cold eyes',
                thumbnail: ColdEyes_tmb,
                image: ColdEyes_img,
                artstation: 'https://www.artstation.com/artwork/4b08Pl'
            }
        case 'girlwithhat':
            return {
                name: 'Girl with hat',
                thumbnail: GirlWithHat_tmb,
                image: GirlWithHat_img,
                artstation: 'https://www.artstation.com/artwork/QzvXnL'
            }
        case 'oceaneyes':
            return {
                name: 'Ocean eyes',
                thumbnail: OceanEyes_tmb,
                image: OceanEyes_img,
                artstation: 'https://www.artstation.com/artwork/mDDQ09'
            }
        case 'tanya':
            return {
                name: 'Tanya',
                thumbnail: Tanya_tmb,
                image: Tanya_img,
                artstation: 'https://www.artstation.com/artwork/3d4OYE'
            }



        case 'medira':
            return {
                name: 'Medira Wolfdaughter',
                thumbnail: Medira_tmb,
                image: Medira_tmb,
                artstation: 'https://www.artstation.com/artwork/ean2zY'
            }
        case 'wizardtower':
            return {
                name: 'Wizard`s tower',
                thumbnail: WizardTower_tmb,
                image: WizardTower_tmb,
                artstation: 'https://www.artstation.com/artwork/zOvg6q'
            }
        case 'guildhall':
            return {
                name: 'Guildhall',
                thumbnail: Guildhall_tmb,
                image: Guildhall_tmb,
                artstation: 'https://www.artstation.com/artwork/48KY3Y'
            }
        
        
    default:
        return null;
    }
}

//                                     ASSETS
// ______________________________________________________________________________

function getAssets(type){
    if(type === '2d'){
        return null
    }
    else{
        return [            
            { // LPNEP
                id: 'LPNEP',
                name: 'Low poly nature environment pack', 
                headerBG: LPNEP_HBG, 
                screenshots: [], 
                description: getAssetDescription('LPNEP'), 
                links: [
                    {name: 'ArtStation', value: 'https://www.artstation.com/marketplace/p/LW2a/low-poly-nature-environment-pack'}, 
                    {name: 'CGTrader', value: 'https://www.cgtrader.com/3d-models/exterior/landscape/low-poly-nature-environment-pack'},
                    {name: 'YouTube', value: 'https://www.youtube.com/watch?v=hFhR_AU2Waw'}
                ]
            }
        ]
    }
}

function getAssetDescription(id){
    switch (id){
        case 'LPNEP':
            return(
                <div>
                    <p>
                        Game ready pack to create low poly nature environment. All models are extra light(30-500 triangles) so can be used for any platform. 15 ambient sound effects will help create believable world. Simple UE4 example map and post process LUTs are also included. 
                        <br/><br/>
                        Total 83 unique models (.fbx, .blend), 15 looped ambient sound effects (.wav) and some more:
                    </p>	
                    <ul>
                        <li>X24 Trees</li>
                        <li>X5 Bushes</li>
                        <li>X27 Stones and cliffs of different sizes</li>
                        <li>X16 Different plants like flowers, kelp and ferns</li>
                        <li>X11 Misc objects like logs and stumps</li>
                        <li>X15 Looped SFX</li>
                        <li>X3 Post processing LUTs</li>                        
                    </ul>
                    <p>Bonus: UE4 scene with all assets, including materials and one blueprint actor for switching to underwater sound mode and back as on video. UE version is 4.21+</p>
                </div>
            )
        default:
            return null
    }
}

export {getProjectData, getThumbnails2D, getThumbnails3D, getAssets};